import React, { lazy } from 'react';
import { CheckCircleIcon, UsersIcon } from 'lucide-react';
import { FadeIn } from '../components/FadeIn';
import { SectionHeading } from '../components/SectionHeading';
import { PageHero } from '../components/PageHero';
import { CTASection } from '../components/CTASection';
interface OverOnsPageProps {
  onNavigate: (page: string) => void;
}
export function OverOnsPage({
  onNavigate
}: OverOnsPageProps) {
  return <div className="w-full" data-id="element-702">
      {/* Hero */}
      <PageHero title="Jouw persoonlijke adviseurs" subtitle="Persoonlijk hypotheek- en verzekeringsadvies door heel Nederland. Snel, eerlijk en zonder gedoe." label="Over ons" data-id="element-703" />

      {/* Editorial Layout - Part 1 */}
      <section className="py-20 md:py-28 bg-white" data-id="element-704">
        <div className="max-w-7xl mx-auto px-4 md:px-8" data-id="element-705">
          <div className="flex flex-col lg:flex-row items-center gap-16" data-id="element-706">
            <div className="w-full lg:w-1/2 order-2 lg:order-1" data-id="element-707">
              <FadeIn data-id="element-708">
                <div className="space-y-6 text-lg text-gray-600 leading-relaxed" data-id="element-709">
                  <p data-id="element-710">
                    Wij zijn het team van JDG Hypotheken | Verzekeringen. Met
                    jarenlange ervaring in de financiële dienstverlening werken
                    wij vanuit één duidelijke visie: financieel advies moet
                    persoonlijker, sneller en zonder gedoe.
                  </p>
                  <p data-id="element-711">
                    Wij houden niet van keuzemenu's of wisselende
                    contactpersonen. Financiële keuzes horen bij de
                    belangrijkste beslissingen in je leven, en die maak je het
                    beste met iemand die je kent en vertrouwt.
                  </p>
                  <p data-id="element-712">
                    Waarom wij dit doen? Omdat het verschil maken juist telt op
                    de momenten die ertoe doen. Als een starter overal nul op
                    het rekest krijgt, een ondernemer vastloopt, of iemand na
                    een scheiding niet weet of zij of hij in het huis kan
                    blijven wonen. Dán willen wij degenen zijn die wél
                    meedenken.
                  </p>
                </div>
              </FadeIn>
            </div>

            <div className="w-full lg:w-1/2 order-1 lg:order-2 relative" data-id="element-713">
              <FadeIn delay={0.2} className="relative z-10" data-id="element-714">
                <img src="https://cdn.magicpatterns.com/uploads/3W8vb2PXbCwvvQCv6k97nv/260409_jdg_hypotheken_en_verzekeringen_by_robert_waasdorp-11.jpg" alt="Het team van JDG Hypotheken | Verzekeringen" loading="lazy" className="w-full max-w-md mx-auto rounded-2xl shadow-card-lg object-cover aspect-[4/3]" data-id="element-715" />
              </FadeIn>
              <div className="absolute top-10 -right-10 w-full h-full bg-warm rounded-2xl -z-10 hidden md:block" data-id="element-716" />
            </div>
          </div>
        </div>
      </section>

      {/* Ons Team Section */}
      <section className="py-20 md:py-28 bg-warm" data-id="element-717">
        <div className="max-w-7xl mx-auto px-4 md:px-8" data-id="element-718">
          <SectionHeading title="Ons team" subtitle="Klein genoeg voor persoonlijk contact, groot genoeg om altijd bereikbaar te zijn." data-id="element-719" />

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto mt-12" data-id="element-720">
            <FadeIn delay={0.1} className="flex flex-col items-center text-center" data-id="element-721">
              <div className="w-full aspect-[3/4] rounded-2xl overflow-hidden mb-6 shadow-card" data-id="element-722">
                <img src="https://cdn.magicpatterns.com/uploads/sKCDxQkuf9T5rmKkf4fChX/260409_jdg_hypotheken_en_verzekeringen_by_robert_waasdorp-9.jpg" alt="Teamlid" className="w-full h-full object-cover hover:scale-105 transition-transform duration-500" data-id="element-723" />
              </div>
              <h3 className="text-xl font-bold text-navy mb-1" data-id="element-724">
                Liesan Christjans
              </h3>
              <p className="text-gold font-medium" data-id="element-725">Hypotheekadviseur</p>
            </FadeIn>

            <FadeIn delay={0.2} className="flex flex-col items-center text-center" data-id="element-726">
              <div className="w-full aspect-[3/4] rounded-2xl overflow-hidden mb-6 shadow-card" data-id="element-727">
                <img src="https://cdn.magicpatterns.com/uploads/2uhV1wD2XTFP3d8EaQ5Sbm/260409_jdg_hypotheken_en_verzekeringen_by_robert_waasdorp-1.jpg" alt="Jordy de Gier" className="w-full h-full object-cover hover:scale-105 transition-transform duration-500" data-id="element-728" />
              </div>
              <h3 className="text-xl font-bold text-navy mb-1" data-id="element-729">
                Jordy de Gier
              </h3>
              <p className="text-gold font-medium" data-id="element-730">
                Oprichter & Hypotheekadviseur
              </p>
            </FadeIn>

            <FadeIn delay={0.3} className="flex flex-col items-center text-center" data-id="element-731">
              <div className="w-full aspect-[3/4] rounded-2xl overflow-hidden mb-6 shadow-card" data-id="element-732">
                <img src="https://cdn.magicpatterns.com/uploads/jxFJtKCn5miYGWYKQdUcvr/260409_jdg_hypotheken_en_verzekeringen_by_robert_waasdorp-3.jpg" alt="Teamlid" className="w-full h-full object-cover hover:scale-105 transition-transform duration-500" data-id="element-733" />
              </div>
              <h3 className="text-xl font-bold text-navy mb-1" data-id="element-734">
                Ruben Pleijster
              </h3>
              <p className="text-gold font-medium" data-id="element-735">Verzekeringsadviseur</p>
            </FadeIn>
          </div>
        </div>
      </section>

      {/* Erkend Financieel Adviseur Badge Section */}
      <section className="py-20 md:py-28 bg-navy text-white" data-id="element-736">
        <div className="max-w-7xl mx-auto px-4 md:px-8" data-id="element-737">
          <div className="flex flex-col md:flex-row items-center gap-12" data-id="element-738">
            <FadeIn className="w-full md:w-1/3 flex justify-center" data-id="element-739">
              <div className="bg-white p-6 rounded-2xl shadow-xl" data-id="element-740">
                <img src="https://cdn.magicpatterns.com/uploads/hLrKue75gCT8qjkamHbfdK/JDG_Erkend_adviseur.png" alt="Erkend Financieel Adviseur" className="w-48 h-auto object-contain" data-id="element-741" />
              </div>
            </FadeIn>
            <div className="w-full md:w-2/3" data-id="element-742">
              <FadeIn delay={0.2} data-id="element-743">
                <h2 className="text-3xl font-bold text-gold mb-6" data-id="element-744">
                  Erkend Financieel Adviseur
                </h2>
                <p className="text-lg text-gray-300 leading-relaxed mb-8" data-id="element-745">
                  Wij voldoen aan de hoogste kwaliteitseisen in de branche.
                  Doorlopend bijgeschoold en getoetst. Zo ben je altijd
                  verzekerd van actueel, onafhankelijk en betrouwbaar advies.
                </p>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-746">
                  <div className="flex items-center gap-3" data-id="element-747">
                    <CheckCircleIcon className="w-6 h-6 text-gold flex-shrink-0" data-id="element-748" />
                    <span className="font-medium" data-id="element-749">
                      Wft-vergunning Hypothecair Krediet
                    </span>
                  </div>
                  <div className="flex items-center gap-3" data-id="element-750">
                    <CheckCircleIcon className="w-6 h-6 text-gold flex-shrink-0" data-id="element-751" />
                    <span className="font-medium" data-id="element-752">
                      Wft-vergunning Schadeverzekeringen
                    </span>
                  </div>
                  <div className="flex items-center gap-3" data-id="element-753">
                    <CheckCircleIcon className="w-6 h-6 text-gold flex-shrink-0" data-id="element-754" />
                    <span className="font-medium" data-id="element-755">
                      Wft-vergunning Levensverzekeringen
                    </span>
                  </div>
                  <div className="flex items-center gap-3" data-id="element-756">
                    <CheckCircleIcon className="w-6 h-6 text-gold flex-shrink-0" data-id="element-757" />
                    <span className="font-medium" data-id="element-758">
                      Erkend Financieel Adviseur
                    </span>
                  </div>
                  <div className="flex items-center gap-3" data-id="element-759">
                    <CheckCircleIcon className="w-6 h-6 text-gold flex-shrink-0" data-id="element-760" />
                    <span className="font-medium" data-id="element-761">Aangesloten bij Kifid</span>
                  </div>
                  <div className="flex items-center gap-3" data-id="element-762">
                    <CheckCircleIcon className="w-6 h-6 text-gold flex-shrink-0" data-id="element-763" />
                    <span className="font-medium" data-id="element-764">
                      Doorlopende opleiding en bijscholing
                    </span>
                  </div>
                </div>
              </FadeIn>
            </div>
          </div>
        </div>
      </section>

      {/* Editorial Layout - Part 2 */}
      <section className="py-20 md:py-28 bg-white" data-id="element-765">
        <div className="max-w-7xl mx-auto px-4 md:px-8" data-id="element-766">
          <div className="flex flex-col lg:flex-row items-center gap-16" data-id="element-767">
            <div className="w-full lg:w-1/2 relative" data-id="element-768">
              <FadeIn className="relative z-10" data-id="element-769">
                <img src="https://cdn.magicpatterns.com/uploads/ch5AjuNpkm4hBPYYqy2imP/260409_jdg_hypotheken_en_verzekeringen_by_robert_waasdorp-7.jpg" alt="Team JDG aan het werk" loading="lazy" className="w-full max-w-md mx-auto rounded-2xl shadow-card-lg object-cover aspect-[4/3]" data-id="element-770" />
              </FadeIn>
              <div className="absolute -bottom-10 -left-10 w-full h-full bg-navy/5 rounded-2xl -z-10 hidden md:block" data-id="element-771" />
            </div>

            <div className="w-full lg:w-1/2" data-id="element-772">
              <FadeIn delay={0.2} data-id="element-773">
                <h2 className="text-3xl font-bold text-navy mb-6" data-id="element-774">
                  Landelijk actief, lokaal geworteld
                </h2>
                <div className="space-y-6 text-lg text-gray-600 leading-relaxed" data-id="element-775">
                  <p data-id="element-776">
                    Wij helpen klanten door heel Nederland, van starters in
                    Utrecht tot ondernemers in Groningen. Dankzij online advies
                    en persoonlijk contact op afstand maakt het niet uit waar je
                    woont. Je krijgt altijd dezelfde betrokken service.
                  </p>
                  <p data-id="element-777">
                    Ons kantoor staat in Badhoevedorp, in het hart van de
                    Haarlemmermeer en Schiphol-regio. Klanten uit Amsterdam,
                    Hoofddorp en omgeving zijn uiteraard ook welkom voor een
                    persoonlijk gesprek op kantoor.
                  </p>
                  <p data-id="element-778">
                    Of je nu starter bent, ondernemer, of in een scheiding ligt:
                    wij nemen de tijd voor je. Geen snelle verkooppraatjes, maar
                    een duurzame relatie. Veel van onze klanten bellen ons jaren
                    later nog steeds voor advies. Dat is voor ons het ultieme
                    bewijs van vertrouwen.
                  </p>
                </div>
              </FadeIn>
            </div>
          </div>
        </div>
      </section>

      {/* Office Location Section */}
      <section className="py-20 md:py-28 bg-warm" data-id="element-779">
        <div className="max-w-7xl mx-auto px-4 md:px-8 text-center" data-id="element-780">
          <FadeIn data-id="element-781">
            <h2 className="text-3xl font-bold text-navy mb-4" data-id="element-782">Ons kantoor</h2>
            <p className="text-lg text-gray-600 mb-12" data-id="element-783">
              Persoonlijk gesprek of liever online? Beide kan.
            </p>
            <div className="relative max-w-4xl mx-auto rounded-2xl overflow-hidden shadow-card-lg" data-id="element-784">
              <img src="https://cdn.magicpatterns.com/uploads/kirqiWzVxRbHNevkp7sjEZ/JDG_Nieuwsbrief_heading_goed_zonder_(1).jpg" alt="JDG Kantoor Badhoevedorp" loading="lazy" className="w-full h-auto object-cover" data-id="element-785" />
              <div className="absolute inset-0 bg-gradient-to-t from-navy/80 via-transparent to-transparent flex items-end justify-center pb-10" data-id="element-786">
                <div className="text-white" data-id="element-787">
                  <p className="text-2xl font-bold mb-2" data-id="element-788">Sloterweg 228</p>
                  <p className="text-lg opacity-90" data-id="element-789">Badhoevedorp</p>
                </div>
              </div>
            </div>
          </FadeIn>
        </div>
      </section>

      {/* CTA Section */}
      <CTASection title="Benieuwd wat wij voor je kunnen betekenen?" subtitle="Plan een vrijblijvende kennismaking. Wij nemen de tijd om jouw situatie te begrijpen." buttonText="Plan een gratis kennismaking" onNavigate={onNavigate} page="contact" variant="dark" data-id="element-790" />
    </div>;
}